import AnimatedLogo from './components/AnimatedLogo';
export default AnimatedLogo;
